import GuestApi from '@/services/GuestApi'

export default {
 /* logIn (user) {
    return Api().post('login/', user).then(function (response) {
      return (response.data)
    })
  },
  checkAuth (token) {
    return Api().post('login/checkAuth', {key: token}).then(function (response) {
      return (response.data)
    })
  },
  reset (user) {
    return Api().post('reset/', user).then(function (response) {
      return (response.data)
    })
  },*/
  getToken(user) {
      return GuestApi().post('sessions', user).then(function (response) {
          return (response)
      })
  }, 
  addPasswordEmail(email){
    return GuestApi().post(`password/${email}`).then(function (response) {
      return (response)
    })
  },
  partialUpdatePassword(token,data){
    return GuestApi().patch(`users/token/${token}/password`,data).then(function (response) {
      return (response)
    })
  },
  getUserByToken(token){
    return GuestApi().get(`users/token/${token}/email`).then(function (response) {
      return (response)
    })
  }
}